export function isQRIS(payment) {
  return payment.name === 'QRIS_ONLINE' || payment.name === 'IFORTE_QRIS' ||
    payment.id === 'MIDE_QRIS' || payment.id === 'IFORTE_QRIS' ||
    payment.payId === 'IFORTE_QRIS';
}

// AI-assisted 2026-09 START: Keep the client-side iForte minimum rule separate from backend availability.
function isIforteQris(paymentMethod) {
  return [
    paymentMethod?.id,
    paymentMethod?.name,
    paymentMethod?.payId,
  ].includes('IFORTE_QRIS');
}

export function getPaymentMinimumAmount(paymentMethod) {
  const limitAmount = Number(paymentMethod?.limitAmount);
  return Number.isFinite(limitAmount) && limitAmount > 0
    ? limitAmount
    : null;
}

export function getPaymentUnavailableReason(paymentMethod, paymentAmount) {
  if (paymentMethod?.available === false) return 'backendUnavailable';

  const isIfortePayment = isIforteQris(paymentMethod) ||
    paymentMethod?.id === 'IFORTE_BLU';
  const minimumAmount = getPaymentMinimumAmount(paymentMethod);
  const normalizedAmount = Number(paymentAmount);
  if (
    isIfortePayment &&
    minimumAmount !== null &&
    Number.isFinite(normalizedAmount) &&
    normalizedAmount < minimumAmount
  ) {
    return 'minimumAmount';
  }

  return null;
}
// AI-assisted 2026-09 END: Keep the client-side iForte minimum rule separate from backend availability.

export function isPaymentAvailable(paymentMethod, paymentAmount) {
  return !getPaymentUnavailableReason(paymentMethod, paymentAmount);
}
